import './paedml-icon.tag'

<paedml-icon-modal>
    <span data-target="{opts.target}" class="btn paedml" data-toggle="modal">
        <paedml-icon icon="{opts.icon}" type="zoom" title="{opts.title}" />
    </span>
</paedml-icon-modal>